'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _most = require('most');

var most = _interopRequireWildcard(_most);

var _curried = require('./_curried');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var switchMap = (0, _curried.curry2)(function (f, stream$) {
  return (0, _pipe2.default)((0, _curried.mmapc)(f), most.switchLatest)(stream$);
});

exports.default = switchMap;